import React from 'react'
import CustomerLocatorModal from 'syf-component-library/ui/patterns/CustomerLocatorModal'
import useCustomerData from './useCustomerData'

interface LostModalProps {
  isOpen: boolean
  closeModal: () => void
}

const LostUserLocatorModal = ({ isOpen, closeModal }: LostModalProps) => {
  const customerData = useCustomerData()

  return (
    <CustomerLocatorModal
      containerId="lost-user-modal"
      id="lost-user"
      isOpen={isOpen}
      closeModal={closeModal}
      customerData={customerData}
      closeButtonProps={{
        className: 'ensightencustomevent',
        'data-title': 'close',
        'data-reason': 'lost user locator',
        'data-object': 'button',
        'data-analytics': 'clicktrackingevent'
      }}
    />
  )
}

export default LostUserLocatorModal
